import { Component, OnInit } from '@angular/core';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { NavController, Platform, MenuController } from '@ionic/angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Screenshot } from '@ionic-native/screenshot/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';


@Component({
  selector: 'app-vasdetails',
  templateUrl: './vasdetails.component.html',
  styleUrls: ['./vasdetails.component.scss'],
})
export class VasdetailsComponent implements OnInit {
  public detailsform: FormGroup;
  languageContext: any;
  languageContext1: any;
  headerTitle: any;
  currentpath;
  screen: any;
  customerName: any;
  customerMobileNumber: any;
  customerEmailId: any;
  state: boolean = false
  fetchImage: any;
  userCode: any;
  checkedbtn: false;
  customerDetailsFileName: any;
  newlat: any;
  newlong: any;
  constructor(public formBuilder: FormBuilder,
    private router: Router,
    public navctrl: NavController,
    public platform: Platform,
    public cmndeclaration: CommonDeclarationService,
    public cmndef: CommonDefinitionService,
    public _DomSanitizer: DomSanitizer,
    private screenshot: Screenshot,
    public menuCtrl: MenuController,
    public api: RestapiService,
    private geolocation: Geolocation,
    public inappbrowser: InAppBrowser,) { 
      this.currentpath = this.router.url;

    if (this.cmndeclaration.LanguageJson) {
      this.languageContext = this.cmndeclaration.LanguageJson['pages'][0].vas_fetch_details_form;

    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageContext = this.cmndeclaration.LanguageJson['pages'][0].vas_fetch_details_form;

    }

    if (this.cmndeclaration.LanguageJson) {
      this.languageContext1 = this.cmndeclaration.LanguageJson['pages'][0].consent_form;
    } else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageContext1 = this.cmndeclaration.LanguageJson['pages'][0].consent_form;
    }
    // this.TrustFrontImgFile = 'assets/images/aadhaar.png';
    // this.TrustBackImgFile = 'assets/images/aadhaar.png';
    // this.pdfIcon = 'assets/images/pdfimg.PNG';
    this.headerTitle = this.languageContext.heading.text;
    console.log(this.headerTitle);
    if(this.cmndef.selectedVAS == "teledoctor") {
      this.fetchImage = "assets/images/khUshi_Banner_Doctor_Consultations.jpg";
    } else {
      this.fetchImage = "assets/images/khUshi_Banner_Diet_Plans_and_More.jpg";
    }
    this.detailsform = formBuilder.group({
      // aadharnumber: ['', Validators.required]
    });
    }
  
  ionViewWillEnter() {
    this.getCustomerDetails();
    this.menuCtrl.swipeEnable(false);

  }
  ngOnInit() {}
  
  async getCustomerDetails() {
    let req: any;
    let res: any;
    await this.cmndef.loaderstart();
    req = {
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId,
    }
    await this.api.postapi("customerDetails", req).then(async data => {
      res = data;
      console.log(res);
      this.customerName = res.customerName;
      this.customerMobileNumber = res.mobileNo;
      this.customerEmailId = res.emailId;
      this.userCode = res.clientId;
      this.newlat = res.lat;
      this.newlong = res.log;

      if (this.customerMobileNumber == "") {
        this.customerMobileNumber == "N/A";
      }
      if(this.customerEmailId == "") {
        this.customerEmailId == "N/A";
      }
      if(this.cmndef.emailScreenRedirection == true) {
        console.log("its true");
        this.customerEmailId = this.cmndef.vasNewEmailId;
      }
      if(this.cmndef.mobileScreenRedirection == true) {
        this.customerMobileNumber = this.cmndef.vasNewMobileNumber;
      }
    });
    await this.cmndef.loaderend();

  }

  changeEmail() {
    this.api.clickenventcap("VasUpdateEmailId");
    this.cmndef.newPreviousPage = this.currentpath;
    this.showinfo(this.languageContext.info.label, "changeEmail");
  }

  changeMobile() {
    this.api.clickenventcap("VasUpdateMobileNumber");
    this.cmndef.newPreviousPage = this.currentpath;
    this.showinfo(this.languageContext.info.label, "changeMobile");
  }

  reset() {
    var self = this;
    setTimeout(function(){ 
      self.state = false;
    }, 3000);
  }

  utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }

  showinfo(msg, info) {
    this.cmndef.presentAlert("", msg, info);
  }

  async submitButton() {
    this.cmndef.Showtoast("Please wait while I fetch the details.");
    if(this.cmndeclaration.BrowserBuild != 1) {
       await this.screenshot.URI(100).then(res => {
          this.screen = res.URI;
          this.cmndef.detailsPageScreenshot = this.screen;
          console.log(this.screen);
          this.state = true;
          this.reset();
        });
    } else {
      this.cmndef.detailsPageScreenshot = '';
    }
    this.customerDetailsFileName = "SS" + this.userCode + "customerDetails.jpg"; 
    let request: any;
    request = {
      "userChatSessionID": localStorage.userChatSessionId,
      "userSessionID": localStorage.userSessionID,
      "userDetails": {
        "policy_holder_name": this.customerName,
        "email_id": this.customerEmailId,
        "mobile_number": this.customerMobileNumber
      },
      "screenshots": [
        {
          "fileContent": this.cmndef.detailsPageScreenshot,
          "fileContentName": this.customerDetailsFileName
        }
      ],
      "consent_flag": "Y",
      "serviceType": this.cmndef.selectedVAS,
      "metadata": this.cmndeclaration.metadata
    }
    console.log(request);
    
      // await this.geolocation.getCurrentPosition().then((resp) => {
       

      //   console.log(resp.coords.latitude);
      //   console.log(resp.coords.longitude);
        var lat = this.newlat;
        var long = this.newlong;
        var channel_api_key = "5f482ad8-254b-4696-9c0c-c66b4c5dae5d";
        var string_1 = '';
        if(this.cmndef.selectedVAS == "teledoctor") {
          console.log("teledoctor selected");
          
          if(this.customerEmailId == "" || this.customerEmailId == null || this.customerEmailId == undefined) {
            string_1 = "channel_api_key=" + channel_api_key + "&full_name=" + this.customerName + "&phone=" + this.customerMobileNumber + "&lat=" + lat + "&long=" + long + "&user_code=" + this.userCode + "&doc_app=true";
          } else if(this.customerMobileNumber == "" || this.customerMobileNumber == null || this.customerMobileNumber == undefined) {
            string_1 = "email=" + this.customerEmailId + "&channel_api_key=" + channel_api_key + "&full_name=" + this.customerName + "&lat=" + lat + "&long=" + long + "&user_code=" + this.userCode + "&doc_app=true";
          } else {
            string_1 = "email=" + this.customerEmailId + "&channel_api_key=" + channel_api_key + "&full_name=" + this.customerName + "&phone=" + this.customerMobileNumber + "&lat=" + lat + "&long=" + long + "&user_code=" + this.userCode + "&doc_app=true";
          }

        } else {
          console.log("health and wellness selected");
          if(this.customerEmailId == "" || this.customerEmailId == null || this.customerEmailId == undefined) {
            string_1 = "channel_api_key=" + channel_api_key + "&full_name=" + this.customerName + "&phone=" + this.customerMobileNumber + "&lat=" + lat + "&long=" + long + "&user_code=" + this.userCode + "&doc_app=false";
          } else if(this.customerMobileNumber == "" || this.customerMobileNumber == null || this.customerMobileNumber == undefined) {
            string_1 = "email=" + this.customerEmailId + "&channel_api_key=" + channel_api_key + "&full_name=" + this.customerName + "&lat=" + lat + "&long=" + long + "&user_code=" + this.userCode + "&doc_app=false";
          } else {
            string_1 = "email=" + this.customerEmailId + "&channel_api_key=" + channel_api_key + "&full_name=" + this.customerName + "&phone=" + this.customerMobileNumber + "&lat=" + lat + "&long=" + long + "&user_code=" + this.userCode + "&doc_app=false";
          }
        }

        var base64Code = this.utf8_to_b64(string_1);
        console.log(base64Code);
        var baseurl = "https://secure.workadvantage.in/api/v1/join_advantageclub_channel?data=" + base64Code;
        if (this.cmndeclaration.BrowserBuild != 1) {
          let browser = this.inappbrowser.create(baseurl, "_blank");
          browser.on('exit').subscribe(() => {
            this.navctrl.navigateRoot("/va/chat");
          }, err => {
            console.error(err);
          });
        } else {
          window.open(baseurl, "_blank");
        }
        this.api.postapi("setVAShistory", request).then(data => {
          console.log("setVAShistory called");
          var res = data;
          console.log(res);
        });

      // });
    // this.api.clickenventcap("VasCustomerDetailsSubmit");
    // sessionStorage.CurrentPage = "/va/consentpage";
    // if(this.cmndeclaration.BrowserBuild != 1) {
    //    await this.screenshot.URI(100).then(res => {
    //       this.screen = res.URI;
    //       this.cmndef.detailsPageScreenshot = this.screen;
    //       console.log(this.screen);
    //       this.state = true;
    //       this.reset();
    //     });
    // } else {
    //   this.cmndef.detailsPageScreenshot = '';
    // }

    // this.navctrl.navigateRoot("/va/consentpage")
  }

}
